import React from "react";

const AuthenticationPrompt = ({ title, prompt }) => {
  return (
    <div className="flex flex-col items-center justify-center text-center my-4 mx-8">
      <div className="text-xl font-medium">{title}</div>
      <div className="text-base font-light">{prompt}</div>
    </div>
  );
};

export default AuthenticationPrompt;
